import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-card.component.html',
})
export class InfoCardComponent {
  title = input('');
  value = input('');
  valueColor = input<'primary' | 'success' | 'warning' | 'danger' | 'muted'>('primary');
  description = input('');
}
